// TODO: This is not the right approach; it should be a class with static methods.
export default {
  name: 'myriander-client',
  methods: {
    api_url: function (path, id = '') {
      return `${process.env.MYR_ROOT}${path}`.replace('{id}', `${id}`)
    },
    api_options: function (fileUploads = false) {
      if (fileUploads) {
        return {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('fonestorm-token')}`
          },
          mode: 'no-cors',
          credentials: 'include'
        }
      } else {
        return {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('fonestorm-token')}`
          },
          mode: 'no-cors',
          credentials: 'include'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/fractel/clients/Myriander.js